import { render, staticRenderFns } from "./DeleteTeamUserModal.vue?vue&type=template&id=4440a3e0&lang=pug"
import script from "./DeleteTeamUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteTeamUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports